import { Box, Button } from '@mui/material';

import FilterSelect from '../../Common/FilterSelect';
import { DEFAULT_DETAIL_FILTERS, VERDICT_FILTER_OPTIONS } from '../constants';
import styles from '../styles';
import {
  SnapshotComparisonDetailFilters as SnapshotComparisonDetailFilterValues,
  TriStateFilter
} from '../types';

/* eslint-disable no-unused-vars */
type SnapshotComparisonDetailFiltersProps = {
  filters: SnapshotComparisonDetailFilterValues;
  indChangeOptions: { label: string; value: string }[];
  tierOptions: { label: string; value: string }[];
  onVerdictChange: (value: TriStateFilter) => void;
  onIndChangeChange: (value: string) => void;
  onTierChange: (value: string) => void;
  onClear: () => void;
};
/* eslint-enable no-unused-vars */

const SnapshotComparisonDetailFilters = ({
  filters,
  indChangeOptions,
  tierOptions,
  onVerdictChange,
  onIndChangeChange,
  onTierChange,
  onClear
}: SnapshotComparisonDetailFiltersProps) => {
  const hasActiveFilters =
    filters.verdict !== DEFAULT_DETAIL_FILTERS.verdict ||
    filters.indChange !== DEFAULT_DETAIL_FILTERS.indChange ||
    filters.tier !== DEFAULT_DETAIL_FILTERS.tier;

  return (
    <Box sx={styles.detailFilters}>
      <FilterSelect
        label='Indication Change'
        value={filters.indChange}
        options={indChangeOptions}
        onChange={onIndChangeChange}
        minWidth={200}
      />
      <FilterSelect
        label='Tier'
        value={filters.tier}
        options={tierOptions}
        onChange={onTierChange}
        minWidth={160}
      />
      <FilterSelect
        label='Agent Verdict'
        value={filters.verdict}
        options={VERDICT_FILTER_OPTIONS}
        onChange={value => onVerdictChange(value as TriStateFilter)}
      />
      {hasActiveFilters && (
        <Button variant='outlined' size='small' onClick={onClear} sx={styles.textButton}>
          Clear filters
        </Button>
      )}
    </Box>
  );
};

export default SnapshotComparisonDetailFilters;
